import { useState, useEffect } from 'react';
import { authService } from '../services/api';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // 检查本地存储中是否有token
        const authStorage = localStorage.getItem('auth-storage');
        if (!authStorage) {
          setLoading(false);
          return;
        }

        const authData = JSON.parse(authStorage);
        if (!authData.state.token) {
          setLoading(false);
          return;
        }

        // 获取用户信息
        const response = await authService.getProfile();
        setUser(response.data);
      } catch (error) {
        console.error('获取用户信息失败:', error);
        // 清除无效的认证信息
        localStorage.removeItem('auth-storage');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  return { user, loading };
}; 